export default __webpack_public_path__ + "static/media/Vatrina2.0f0040b5.png";